export default () => {

    const $body = $('body')
    
    if ( $('.js-cookieBar--accept').length ) {
        $body.addClass('has-cookie-bar')
    }

    if ( $('.js-cookieBar--info').length ) {
        $body.addClass('has-info-cookie-bar')
    }

    $('.js-cookieClose').click( function(e)
    {
        e.preventDefault();

        const $this = $(this)
        const $bar = $this.closest('.js-cookieBar')
        const cookieName = $bar.attr('data-name')

        if ( $this.closest('.js-cookieBar--accept').length ) {
            $body.removeClass('has-cookie-bar')
        } else if ( $this.closest('.js-cookieBar--info').length ) {
            $body.removeClass('has-info-cookie-bar')
        }

        $bar.css('display', 'none');

        setCookie(cookieName);
    });
    
    function setCookie(cookieName) 
    {
        var expiryDays = 100,
            cookieValue = 'true',
            today = new Date(),
            expire = new Date();

        expire.setTime( today.getTime() + 3600000 * 24 * expiryDays );

        document.cookie = cookieName + '=' + escape( cookieValue ) + ';expires=' + expire.toGMTString() + ';path=/';
    }
}